import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../lib/api";

function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await adminLogin(email.trim(), password);
      navigate("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-ink flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <img src="/logo-white.png" alt="Yadid Advisory" className="h-14 w-auto mx-auto" />
          <p className="eyebrow text-brass mt-6">Insights Editor</p>
        </div>
        <form onSubmit={onSubmit} data-testid="admin-login-form" className="space-y-8">
          <div>
            <label className="eyebrow text-ivory/50 block mb-3">Email</label>
            <input
              type="email"
              data-testid="admin-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border-0 border-b border-white/20 py-3 text-lg text-ivory font-light focus:outline-none focus:border-brass transition-colors"
            />
          </div>
          <div>
            <label className="eyebrow text-ivory/50 block mb-3">Password</label>
            <input
              type="password"
              data-testid="admin-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border-0 border-b border-white/20 py-3 text-lg text-ivory font-light focus:outline-none focus:border-brass transition-colors"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-400 font-light">
              {error}
            </p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-brass text-ink py-4 text-[0.78rem] tracking-[0.16em] uppercase font-semibold transition-all duration-500 hover:bg-[#d9bd93] disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
